import React from 'react';
import { Form, FormLabel, Button } from 'react-bootstrap';
import { SubscriptionType } from './types/SubscriptionTypes.ts';
import { formatIntegerCentAmount } from '../utilities/TextFormatters.ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faSpinner } from '@fortawesome/free-solid-svg-icons';

interface SelectSubscriptionPriceProps {
  minPrice: number;
  maxPrice: number;
  selectedSubscription: SubscriptionType;
  setSelectedPrice: (price: number) => void;
  selectedPrice: number;
  fetchingPaymentIntent: boolean;
  onContinue: () => void;
  continueText?: string;
}

export const SelectSubscriptionPrice = ({ minPrice, maxPrice, setSelectedPrice, selectedSubscription, selectedPrice, onContinue, fetchingPaymentIntent, continueText = "Continue to Payment" }: SelectSubscriptionPriceProps) => {

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedPrice(parseInt(e.target.value));
  };

  return (
    <Form>
      <div className='text-left'>
        <p>
          Thank you for choosing to support RepTool! I know subscription based services can be a pain, that's why I've made it as affordable as possible. You can choose any price between ${formatIntegerCentAmount(minPrice)} and ${formatIntegerCentAmount(maxPrice)}/mo to support the development of RepTool.
          Your subscription will allow me to continue to develop and maintain RepTool, as well as provide you with the best possible experience. You can cancel your subscription at any time. Thank you again for your support!
        </p>
        <p><i>- Drew Fairchild (Developer & Owner)</i></p>
      </div>

      <h4 className='mt-3'>{selectedSubscription.name} Subscription</h4>
      <h2 className='text-light'>${formatIntegerCentAmount(selectedPrice)}/mo</h2>
      <FormLabel>Select your subscription price:</FormLabel>
      <div>
        <Form.Range
          min={minPrice}
          max={maxPrice}
          value={selectedPrice}
          step='50'
          className='mt-2 mb-2'
          style={{
            transform: 'scale(2)',
            width: 150
          }}
          onChange={handleChange}
        />
      </div>
      <Button variant="outline-light" disabled={fetchingPaymentIntent} onClick={onContinue}>{!fetchingPaymentIntent ? <>{continueText} <FontAwesomeIcon icon={faArrowRight} className='ml-2' /></> : <FontAwesomeIcon icon={faSpinner} spin />}</Button>
    </Form>
  );
};

